import { motion } from "framer-motion";
import React from 'react';
import profilePic from '../assests/gitpic.png'; // <-- Import the image here

const Hero = () => {
    return (
        <section className="hero m-4">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7" >
                    <motion.h3
                            className="display-5 fw-bold"
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                        >
                            Hi I am <strong>Madiha Fatima</strong>! Building Modern Web Apps with the MERN Stack
                        </motion.h3>

                        {/* Animated Paragraph */}
                        <motion.p
                            className="lead small-muted"
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
                        >
                            I create responsive, accessible, and user-focused web apps using React, Node, MongoDB and Bootstrap.
                        </motion.p>

                        {/* Buttons */}
                        <motion.div
                            className="mt-3"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6, duration: 0.6 }}
                        >
                            <a href="#projects" className="btn btn-outline-secondary me-2 ">View My Work</a>
                            <a href="#contact" className="btn btn-outline-secondary ">Contact Me</a>
                        </motion.div>
                    </div>
                    <div className="col-lg-5 text-lg-end mt-4 mt-lg-0">
                        <div className="p-4 d-inline-block hero-side">
                            <div className="d-flex justify-content-center justify-content-lg-end at-455">
                                <div className="image-header">
                                    <motion.img
                                        src={profilePic}
                                        alt="Profile"
                                        className="image-header2"
                                        initial={{ rotate: -180, scale: 0, opacity: 0 }}
                                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                                        transition={{ duration: 0.8, ease: "easeOut" }}
                                    />


                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
}

export default Hero;
